var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"head"},[_vm._v("\n      Panasonic\n  ")]),_vm._m(0),_c('div',{staticClass:"security"},[_c('p',[_vm._v(_vm._s(_vm.model.message))])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('span',[_vm._v("松下开关插座")]),_c('span',{staticClass:"title-weight"},[_vm._v("防伪查询平台")])])
}]

export { render, staticRenderFns }